function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("radialGradient", {
  id: "mail-b",
  cx: "100%",
  cy: ".837%",
  r: "84.911%",
  fx: "100%",
  fy: ".837%",
  gradientTransform: "matrix(-.58885 .579 -.41816 -.81533 1.592 -.564)"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFE72E"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFAD2F"
})), React.createElement("path", {
  id: "mail-a",
  d: "M3 .962c-1.656 0-3 1.344-3 3.001v20a3 3 0 003 2.999h30a3 3 0 003-2.999v-20a3.001 3.001 0 00-3-3.001"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 4.25)"
}, React.createElement("mask", {
  id: "mail-c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#mail-a"
})), React.createElement("path", {
  fill: "url(#mail-b)",
  d: "M33 26.963H3a3 3 0 01-3-3v-20a3 3 0 013-3h30a3 3 0 013 3v20a3 3 0 01-3 3",
  mask: "url(#mail-c)"
}), React.createElement("path", {
  fill: "#FFF",
  fillOpacity: 0.16,
  d: "M3 26.963h.839l17.562-12.716L3.056.963H3a3 3 0 00-3 3v20a3 3 0 003 3",
  mask: "url(#mail-c)"
}), React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M18 26.963h.839l17.562-12.716L18.056.963H18a3 3 0 00-3 3v20a3 3 0 003 3",
  mask: "url(#mail-c)",
  transform: "matrix(-1 0 0 1 51.401 0)"
}), React.createElement("path", {
  fill: "#FFE72E",
  d: "M.02 3.762L18 16.662l17.979-12.9A2.99 2.99 0 0033 .963H3a2.99 2.99 0 00-2.98 2.8",
  mask: "url(#mail-c)"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M18 11.772L2.977.965A3 3 0 000 3.963l4 2.665L18 16.7 32 6.63l4-2.666A3 3 0 0033.023.965L18 11.772z",
  mask: "url(#mail-c)"
}));

var SvgIcMail = function SvgIcMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_mail.686d4222.svg";
export { ForwardRef as ReactComponent };